import * as React from 'react';
import { StickyCallToAction, Price } from '@grandvisionhq/common';
import { useFramesEcommContext } from '../../context/FramesEcommContext.js';
import { FramesCTA } from '../FramesCTA/FramesCTA.js';

const FramesStickyCTA = ({ className  })=>{
    const { displayPrice  } = useFramesEcommContext();
    var _discountedPrice;
    return /*#__PURE__*/ React.createElement(StickyCallToAction, {
        className: className,
        button: /*#__PURE__*/ React.createElement(FramesCTA, null),
        price: /*#__PURE__*/ React.createElement(Price, {
            value: (_discountedPrice = displayPrice.discountedPrice) !== null && _discountedPrice !== void 0 ? _discountedPrice : displayPrice.originalPrice,
            currency: displayPrice.currency,
            centAmount: false,
            type: displayPrice.discountedPrice ? 'discount' : 'default'
        })
    });
};

export { FramesStickyCTA };
//# sourceMappingURL=FramesStickyCTA.js.map
